export enum BusinessTypeEnum {
	SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
	CORPORATION = 'CORPORATION',
	PARTNERSHIP = 'PARTNERSHIP',
}
